import { AllowedCallTypes, CrudConfig } from "seneca-common/utils/apiStates";

export const PREMIUM_TRIALS_STATE_SLICE_PATH = "premiumTrials";

export const trialsCrudStateConfig: CrudConfig = {
  name: "trials",
  path: "seneca/premium-trials/meta/",
  idFieldName: "type",
  callTypes: [AllowedCallTypes.FETCH_ALL, AllowedCallTypes.UPDATE]
};

export const FeatureTypes = Object.freeze({
  WRONG_ANSWERS: "WRONG_ANSWERS"
});
